import { Amplify } from 'aws-amplify';

const awsConfig = {
  Auth: {
    Cognito: {
      userPoolId: process.env.REACT_APP_USER_POOL_ID || '',
      userPoolClientId: process.env.REACT_APP_USER_POOL_CLIENT_ID || '',
      region: process.env.REACT_APP_AWS_REGION || 'us-east-1',
      authenticationFlowType:
        process.env.REACT_APP_AWS_AUTHENTICATIONFLOW_TYPE || 'CUSTOM_WITHOUT_SRP',
    },
  },
};

Amplify.configure(awsConfig);

export default awsConfig;
